import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MobileProvider } from "../providers/MobileContext";
import styles from "../App.module.scss";
import MainPage from "../pages/main/MainPage";
import PartnersPage from "../pages/partners/PartnersPage";
import RegisterPartnerPage from "../pages/registerPartner/RegisterPartnerPage";
import ContactPage from "../pages/contact/ContactPage";
import ServicePage from "../pages/service/ServicePage";
import PolicyPage from "../pages/policy/PolicyPage";
import PartnerHomePage from "../pages/PartnerHome/PartnerHomePage";
import ArticlePage from "../pages/Article/ArticlePage";

const Routers = () => {
  return (
    <div className={`${styles.app}`}>
      <MobileProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" exact element={<MainPage />} />
            <Route path="/partners" element={<PartnersPage />} />
            <Route path="/register_partner" element={<RegisterPartnerPage />} />
            <Route path="/partner/:id" element={<PartnerHomePage />} />
            <Route path="/article/articles/:id" element={<ArticlePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/service" element={<ServicePage />} />
            <Route path="/policy" element={<PolicyPage />} />
          </Routes>
        </BrowserRouter>
      </MobileProvider>
    </div>
  );
};

export default Routers;
